module.exports = __webpack_public_path__ + "img/Barrel.231b1eb5.png";